/* Nancy doctor pages: review notes, video chapters, filters, quick look. Safe to load more than once. */
(function () {
  if (window.__ndDoctors) return;
  window.__ndDoctors = true;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    // Review notes show only with ?notes=1 in the URL.
    if (/[?&]notes=1\b/.test(location.search)) document.documentElement.classList.add("nd-notes-on");

    // Video chapters.
    document.querySelectorAll("[data-nd-chapter]").forEach(function (b) {
      b.addEventListener("click", function () {
        var vid = document.getElementById(b.getAttribute("data-nd-video"));
        if (!vid) return;
        vid.currentTime = +b.getAttribute("data-nd-chapter");
        var p = vid.play();
        if (p && p.catch) p.catch(function () {});
        vid.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    });

    // Topic filters on the doctors grid.
    document.querySelectorAll("[data-nd-filters]").forEach(function (bar) {
      var grid = document.getElementById(bar.getAttribute("data-nd-filters"));
      var chips = bar.querySelectorAll("button");
      chips.forEach(function (c) {
        c.addEventListener("click", function () {
          chips.forEach(function (x) { x.classList.remove("is-on"); });
          c.classList.add("is-on");
          var f = c.getAttribute("data-f");
          grid.querySelectorAll("[data-focus]").forEach(function (card) {
            var list = card.getAttribute("data-focus").split("|");
            card.style.display = !f || list.indexOf(f) >= 0 ? "" : "none";
          });
        });
      });
    });

    // Quick look: copies the hidden template inside each card into the dialog.
    var dlg = document.getElementById("nd-quick");
    if (dlg) {
      document.querySelectorAll("[data-nd-quick]").forEach(function (b) {
        b.addEventListener("click", function () {
          var tpl = document.getElementById(b.getAttribute("data-nd-quick"));
          if (!tpl) return;
          dlg.innerHTML = '<button class="nd-quick__close" aria-label="Close">×</button>' + tpl.innerHTML;
          dlg.querySelector(".nd-quick__close").addEventListener("click", function () { dlg.close(); });
          dlg.showModal();
        });
      });
      dlg.addEventListener("click", function (e) { if (e.target === dlg) dlg.close(); });
    }
  });
})();

/* Source links inside a clickable card: open the original post in a new tab without following the card link. */
(function () {
  if (window.__ndSaid) return;
  window.__ndSaid = true;
  function open(e) {
    var el = e.target.closest && e.target.closest('.nd-said__go');
    if (!el) return;
    if (e.type === 'keydown' && e.key !== 'Enter') return;
    e.preventDefault();
    e.stopPropagation();
    window.open(el.getAttribute('data-href'), '_blank', 'noopener');
  }
  document.addEventListener('click', open, true);
  document.addEventListener('keydown', open, true);
})();
